import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, ButtonGroup } from 'react-bootstrap';
import { Row, Col, FormGroup, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';
import { sendRequestAccess, requestAccesOpenPage } from './../../../../users';

import queryString from 'query-string'

import config from '../../../../../config'

import './styles';
import right_Check_Image from 'images/icon_notification_success.png';

class RequestAccess extends Component {
    constructor(props) {
        super(props);

        const QS = queryString.parse(props.location.search)

        this.state = {
            submitForm: false,
            email: QS.email ? QS.email : '',
            firstName: '',
            lastName: '',
            jobTitle: '',
            phoneExt: '',
            phone: '',
            brokerageLocation: '',
            errorGroup: {},
            errorStatus: false
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentWillReceiveProps({ signup: { status, statusMessage, requestStatus }, error }) {
        if (requestStatus) {
            this.setState({ submitForm: true });
        } else {
            this.setState({
                errorStatus: true
            });
        }
    }

    handleSubmit(e) {
        e.preventDefault();

        const {
            email,
            firstName,
            lastName,
            phone,
            phoneExt,
            jobTitle,
            brokerageLocation
        } = this.state;
        const errorGroup = {
            email: email.length === 0,
            firstName: firstName.length === 0,
            lastName: lastName.length === 0,
            phone: phone.length === 0,
            brokerageLocation: brokerageLocation.length === 0
        };
        const errorStatus = Object.keys(errorGroup).every(k => !errorGroup[k]);

        if (!errorStatus) {
            this.setState({
                errorGroup,
                errorStatus: !errorStatus
            });
        } else {
            const userData = {
                email,
                firstName,
                lastName,
                phone,
                phoneExt,
                brokerageLocation,
                jobTitle
            };
            this.props.sendRequestAccess({ userData });
        }
    }

    componentDidMount() {
        const { email } = this.state;
        this.props.requestAccesOpenPage({ email });

        if (this.emailField) {
            this.emailField.focus();
        }
    }

    handleChange(e) {
        let errorStatus = this.state.errorStatus;
        const previousErrorGroup = this.state.errorGroup;

        const currentErrorGroup = {
            [e.target.id]: e.target.value.length === 0
        };

        const errorGroup = { ...previousErrorGroup, ...currentErrorGroup };

        if (this.state.errorStatus) {
            const booleanValues = Object.values(errorGroup);
            errorStatus = booleanValues.every(booleanFlag => (booleanFlag ? true : false));
        }

        this.setState({ [e.target.id]: e.target.value, errorGroup, errorStatus });
    }

    render() {
        const {
            submitForm,
            email,
            firstName,
            lastName,
            jobTitle,
            phoneExt,
            phone,
            brokerageLocation,
            errorGroup,
            errorStatus
        } = this.state;

        return (
            <div className="container">
                {submitForm && (
                    <VerifyMessage email={email} />
                )}
                <Row>
                    <Col mdOffset={4} md={4}>
                        {!submitForm && (
                            <form onSubmit={e => this.handleSubmit(e)}>
                                <h1>Request Access to Owner&apos;s Edge</h1>
                                <p>Unfortunately we don&apos;t recognize your email address</p>
                                <FormGroup controlId="email">
                                    <ControlLabel>Email</ControlLabel>
                                    <FormControl
                                        id="email"
                                        type="text"
                                        label="Email"
                                        value={email}
                                        onChange={this.handleChange}
                                        inputRef={ref => { this.emailField = ref }}
                                    />
                                    <ErrorBlock errorFlag={errorGroup.email} />
                                </FormGroup>
                                <FormGroup controlId="firstName">
                                    <ControlLabel>First Name</ControlLabel>
                                    <FormControl
                                        id="firstName"
                                        type="text"
                                        label="Text"
                                        value={firstName}
                                        onChange={this.handleChange}
                                    />
                                    <ErrorBlock errorFlag={errorGroup.firstName} />
                                </FormGroup>
                                <FormGroup controlId="lastName">
                                    <ControlLabel>Last Name</ControlLabel>
                                    <FormControl
                                        id="lastName"
                                        type="text"
                                        label="Text"
                                        value={lastName}
                                        onChange={this.handleChange}
                                    />
                                    <ErrorBlock errorFlag={errorGroup.lastName} />
                                </FormGroup>
                                <FormGroup controlId="jobTitle">
                                    <ControlLabel>Job Title</ControlLabel>
                                    <FormControl
                                        id="jobTitle"
                                        type="text"
                                        label="Text"
                                        placeholder="optional"
                                        value={jobTitle}
                                        onChange={this.handleChange}
                                    />
                                </FormGroup>
                                <Row>
                                    <Col xs={8} sm={8} md={8} lg={8}>
                                        <FormGroup controlId="phone">
                                            <ControlLabel>Phone Number</ControlLabel>
                                            <FormControl
                                                id="phone"
                                                type="text"
                                                label="Text"
                                                value={phone}
                                                onChange={this.handleChange}
                                            />
                                            <ErrorBlock errorFlag={errorGroup.phone} />
                                        </FormGroup>
                                    </Col>
                                    <Col xs={4} sm={4} md={4} lg={4}>
                                        <FormGroup controlId="phoneExt">
                                            <ControlLabel>Ext</ControlLabel>
                                            <FormControl
                                                id="phoneExt"
                                                type="text"
                                                label="Text"
                                                placeholder="optional"
                                                value={phoneExt}
                                                onChange={this.handleChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <FormGroup controlId="brokerageLocation">
                                    <ControlLabel>Brokerage and Location</ControlLabel>
                                    <FormControl
                                        id="brokerageLocation"
                                        type="text"
                                        label="brokerageLocation"
                                        value={brokerageLocation}
                                        onChange={this.handleChange}
                                    />
                                    <ErrorBlock errorFlag={errorGroup.brokerageLocation} />
                                </FormGroup>
                                <Row style={{ marginBottom: '20px' }}>
                                    <Col mdOffset={2} md={11}>
                                        <ButtonGroup>
                                            <Button bsStyle="default" type="submit">
                                                Request Access
                                            </Button>
                                            <a
                                                className="cancelLink"
                                                href={`${config.landingPageUrl}`}
                                            >
                                                Cancel
                                            </a>
                                            <ErrorBlock
                                                errorFlag={errorStatus}
                                                errorMessage="*Not All required fields are filled out!"
                                            />
                                        </ButtonGroup>
                                    </Col>
                                </Row>
                            </form>
                        )}
                    </Col>
                </Row>
            </div>
        );
    }
}
const ErrorBlock = ({ errorFlag, errorMessage = '*Required' }) => {
    return errorFlag ? <HelpBlock className="helpBlockRed">{errorMessage}</HelpBlock> : null;
};

const VerifyMessage = props => {
    return (
        <div className="verifyMessage">
            <div className="pull-left mr-x2 ml-x2">
                <img src={right_Check_Image} alt="Argo" />
            </div>
            <div className="pull-right">
                <h1>An underwriter will be in touch</h1>
                <p>
                    We will verify your details and send invitation to {props.email}, or contact
                    you for more information.
                </p>
                <a className="btn btn-link pn mt" href={`${config.landingPageUrl}`}>Back to product overview</a>
            </div>
        </div>
    );
};

const mapStateToProps = store => {
    return {
        signup: store.users.signup
    };
};

RequestAccess.propTypes = {
    error: PropTypes.bool,
};

export default connect(
    mapStateToProps,
    {
        sendRequestAccess,
        requestAccesOpenPage
    }
)(RequestAccess);
